import Head from 'next/head';
import React from 'react';
import { About } from '../components';
import { withLayout } from '../Layout/Layout';

export const AboutHOC = ({ setLoginDialogState }) => {
  return (
    <>
      <Head>
        <link rel="canonical" href={`${process.env.apiUrl}/about`} />
        <meta
          name="description"
          content={
            'Learn more about First-Class.com, your trusted source for luxury travel and lifestyle content. Discover our mission, team, and dedication to providing premium insights'
          }
        />
        <title>About First-Class: Your Premium Travel Resource</title>
      </Head>
      <About setLoginDialogState={setLoginDialogState} />
    </>
  );
};
export default withLayout(AboutHOC, true);
